// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Start: Sticky footer support */
body {
  display: flex;
  height: 100vh;
  flex-direction: column;
}

main {
  flex: 1 0 auto;
  display: flex;
}

/* End: Sticky footer support */`, "",{"version":3,"sources":["webpack://./src/app.component.scss"],"names":[],"mappings":"AACA,iCAAA;AACA;EACI,aAAA;EACA,aAAA;EAGA,sBAAA;AAAJ;;AAGA;EAGI,cAAA;EACA,aAAA;AAAJ;;AAEA,+BAAA","sourcesContent":["\n/* Start: Sticky footer support */\nbody {\n    display: flex;\n    height: 100vh;\n    -ms-flex-direction: column;\n    -webkit-flex-direction: column;\n    flex-direction: column;\n}\n\nmain {\n    -ms-flex: 1 0 auto;\n    -webkit-flex: 1 0 auto;\n    flex: 1 0 auto;\n    display: flex;\n}\n/* End: Sticky footer support */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
